export function getDate(state) {
    return state.date
}

export function getType(state) {
    return state.type_id
}

